/**
 * Service to handle location lookups using OpenStreetMap's Nominatim API
 * which utilizes open data sources similar to OpenAddresses.
 */
export const detectCity = async () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by your browser'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          // Using Nominatim (OpenStreetMap) for reverse geocoding
          // This is the open-source alternative to Google Maps Geocoding
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=10&addressdetails=1`,
            {
              headers: {
                'Accept-Language': 'en',
                'User-Agent': 'SohLocal-Marketplace-App'
              }
            }
          );
          const data = await response.json();

          if (data && data.address) {
            const city = data.address.city || data.address.town || data.address.village || data.address.suburb || data.address.county;
            const state = data.address.state;
            const country = data.address.country;

            resolve({
              city,
              state,
              country,
              fullName: city ? `${city}, ${state || country}` : country,
              lat: latitude,
              char: longitude
            });
          } else {
            reject(new Error('City not found'));
          }
        } catch (error) {
          reject(new Error('Failed to fetch location details'));
        }
      },
      (error) => {
        let msg = 'Permission denied';
        if (error.code === 2) msg = 'Position unavailable';
        if (error.code === 3) msg = 'Timeout';
        reject(new Error(msg));
      },
      { timeout: 10000 }
    );
  });
};